import React from "react";

export type UserBadgeType = "founder";

interface UserBadgeProps {
  type: UserBadgeType;
  label?: string;
  className?: string;
  size?: number;
}

const badgeSvgs: Record<UserBadgeType, (size: number) => JSX.Element> = {
  founder: (size: number) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      className="drop-shadow-lg"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <radialGradient id="robot-badge-bg" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#fffbe6" />
          <stop offset="100%" stopColor="#ea384c" />
        </radialGradient>
        <linearGradient id="robot-face" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#f3f4f6" />
          <stop offset="100%" stopColor="#e5e7eb" />
        </linearGradient>
        <linearGradient id="robot-accent" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#ea384c" />
          <stop offset="100%" stopColor="#a21caf" />
        </linearGradient>
        <filter id="glow" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="3" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      {/* Badge background */}
      <circle
        cx="32"
        cy="32"
        r="28"
        fill="url(#robot-badge-bg)"
        stroke="#fff"
        strokeWidth="3"
      />
      {/* Robot head */}
      <g>
        {/* Antenna */}
        <rect x="29.5" y="10" width="5" height="10" rx="2.5" fill="url(#robot-accent)" />
        <circle cx="32" cy="10" r="3" fill="url(#robot-accent)" stroke="#fff" strokeWidth="1" />
        {/* Head */}
        <rect x="16" y="18" width="32" height="28" rx="14" fill="url(#robot-face)" stroke="#ea384c" strokeWidth="2" />
        {/* Eyes */}
        <ellipse cx="24.5" cy="32" rx="4" ry="4.5" fill="#fff" stroke="#ea384c" strokeWidth="1.5" />
        <ellipse cx="39.5" cy="32" rx="4" ry="4.5" fill="#fff" stroke="#ea384c" strokeWidth="1.5" />
        <ellipse cx="24.5" cy="32" rx="1.5" ry="1.5" fill="#ea384c" />
        <ellipse cx="39.5" cy="32" rx="1.5" ry="1.5" fill="#ea384c" />
        {/* Smile */}
        <path
          d="M25 40c2 3 12 3 14 0"
          stroke="#ea384c"
          strokeWidth="2"
          strokeLinecap="round"
          fill="none"
        />
        {/* Cheeks */}
        <ellipse cx="20" cy="36" rx="1.5" ry="1" fill="#ea384c" opacity="0.3" />
        <ellipse cx="44" cy="36" rx="1.5" ry="1" fill="#ea384c" opacity="0.3" />
        {/* Ears */}
        <ellipse cx="14" cy="32" rx="3" ry="6" fill="url(#robot-accent)" opacity="0.7" />
        <ellipse cx="50" cy="32" rx="3" ry="6" fill="url(#robot-accent)" opacity="0.7" />
      </g>
      {/* Label */}
    </svg>
  ),
};

const badgeLabels: Record<UserBadgeType, string> = {
  founder: "Founder's Program",
};

const UserBadge: React.FC<UserBadgeProps> = ({
  type,
  label,
  className = "",
  size = 48,
}) => {
  return (
    <div className={`flex flex-col items-center ${className}`}>
      {badgeSvgs[type](size)}
      <span className="text-xs font-semibold mt-1 text-center text-primary">
        {label || badgeLabels[type]}
      </span>
    </div>
  );
};

export default UserBadge;